import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function AppButton({ 
  type = "button",
  variant = "primary", // "primary" or "logout"
  disabled = false,
  loading = false,
  onClick,
  children,
  className = "",
  text = null, // translation key for button text
  loadingText = null, // optional translation key for loading state
  icon = null, // Font Awesome icon name from ICONS constant
  iconPosition = "left", // "left" or "right"
}) {
  const { t } = useTranslation();

  const baseClass = variant === "logout" ? "logout-btn" : "btn";
  const buttonClass = `${baseClass} ${className}`.trim();

  const getDisplayText = () => {
    if (text) {
      return loading && loadingText ? t(loadingText) : t(text);
    }
    return children;
  };

  const getIcon = () => {
    if (loading) return <FontAwesomeIcon icon="spinner" spin />;
    if (icon) return <FontAwesomeIcon icon={icon} />;
    return null;
  };

  const displayText = getDisplayText();
  const iconElement = getIcon();

  const renderContent = () => {
    if (!iconElement) return displayText;

    const spacing = displayText ? '8px' : '0';
    
    if (iconPosition === "right") {
      return (
        <>
          {displayText && <span style={{ marginRight: spacing }}>{displayText}</span>}
          {iconElement}
        </>
      );
    }
    
    return (
      <>
        {iconElement}
        {displayText && <span style={{ marginLeft: spacing }}>{displayText}</span>}
      </>
    );
  };

  return (
    <button
      type={type}
      className={buttonClass}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {renderContent()}
    </button>
  );
} 